import { IAdminTeamHoleResultsStore } from './store';

import api, { request } from '../../../api';
import { groupBy } from '../../../contrib/utils';
import { IErrorsStore } from '../../errors/store';
import { IActionGroup, IStore } from '../../index';

export interface IAdminTeamHoleResultsActions extends IActionGroup {
  get: (
    roundId: number,
    player?: boolean
  ) => { adminTeamHoleResults?: IAdminTeamHoleResultsStore; errors?: IErrorsStore };
}

const actions: IActionGroup = {
  get: async (state: IStore, roundId: number, player?: boolean) => {
    if (state.adminTeamHoleResults[roundId]) {
      return state;
    }

    const response = await request.get(api.teamRoundHoleLeaderboardResults(roundId, player));

    if (response.error) {
      return {
        errors: { adminTeamHoleResults: { msg: 'Error retrieving the Event Round Details.' } }
      };
    }

    const groupedByFlight = groupBy(response, 'flightId');

    return {
      ...state,
      adminTeamHoleResults: { ...state.adminTeamHoleResults, [roundId]: groupedByFlight }
    };
  }
};

export default actions;
